/* eslint-disable react/prop-types */
import { useState } from "react";
import { Badge, Modal, Nav, Tab, Table } from "react-bootstrap";
import avater1 from "../../../assets/images/avatar/1.jpg";
import PageTitle from "../../layouts/PageTitle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import { Step, Stepper } from "react-form-stepper";
import English from "../../../assets/images/english.png";
import French from "../../../assets/images/french.png";
import Spanish from "../../../assets/images/spanish.png";
import Portgual from "../../../assets/images/pt.png";
import Arabic from "../../../assets/images/saudi.png";

const CreateProduct = () => {
  const [reviewToggle, setReviewToggle] = useState(false);
  const [star, setStar] = useState(3);
  const [goSteps, setGoSteps] = useState(0);

  const [isMultipleSize, setIsMultipleSize] = useState(false);

  const CustomClearText = () => "clear all";
  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    // height : 70,
    color: state.isFocused ? "blue" : "black",
  });

  const options = [
    { value: "small", label: "Small" },
    { value: "medium", label: "Medium" },
    { value: "large", label: "Large" },
    { value: "xlarge", label: "X-Large" },
  ];

  return (
    <>
      <PageTitle activeMenu="Create Product" motherMenu="Kitchen" />
      <div className="row">
        <div className="col-lg-12">
          <div className="form-wizard ">
            <Stepper className="nav-wizard" activeStep={goSteps} label={true}>
              <Step className="nav-link" onClick={() => setGoSteps(0)} />
              <Step className="nav-link" onClick={() => setGoSteps(1)} />
              <Step className="nav-link" onClick={() => setGoSteps(2)} />
              <Step className="nav-link" onClick={() => setGoSteps(3)} />
            </Stepper>
            {goSteps === 0 && (
              <>
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="customCheckBox1"
                    checked={isMultipleSize}
                    onChange={(e) => setIsMultipleSize(e.target.checked)}
                    style={{
                      height: 25,
                      width: 25,
                      backgroundColor: "#FA8072",
                      border: "1px solid #FA8072",
                    }}
                  />
                  <label
                    className="form-check-label pt-2"
                    htmlFor="customCheckBox1"
                  >
                    Have multiple size
                  </label>
                </div>
                <h4 className="mt-3">Product price</h4>
                <div className="form-group mt-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Product price value"
                  />
                </div>
                {isMultipleSize && (
                  <>
                    <h4 className="mt-3">Product size </h4>
                    <Select
                      closeMenuOnSelect={false}
                      components={{ ClearIndicator }}
                    
                      styles={{ clearIndicator: ClearIndicatorStyles }}
                      //  defaultValue={[colourOptions[4], colourOptions[5]]}
                      isMulti
                      options={options}
                     // className="form-control"
                      
                    />
                    <Table className="mt-3" responsive bordered>
                      <thead>
                        <tr>
                          <th>Size</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Badge bg="" className="badge-primary light">
                              Small
                            </Badge>
                          </td>

                          <td className="color-primary">$21.56</td>
                        </tr>
                        <tr>
                          <td>
                            <Badge bg="" className="badge-primary light">
                              Medium
                            </Badge>
                          </td>

                          <td className="color-primary">$21.56</td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                )}

                <div className="text-end toolbar toolbar-bottom p-2">
                  <button
                    className="btn btn-primary sw-btn-next"
                    onClick={() => setGoSteps(1)}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
            {goSteps === 1 && (
              <>
                <h4>Upload Photo</h4>
                {Array.from({ length: 4 }).map((_, index) => (
                  <input
                    key={index} // Use index as key since it's a static iteration
                    className="form-control mb-3" // Add margin for better spacing
                    type="file"
                  />
                ))}

                <div className="text-end toolbar toolbar-bottom p-2">
                  <button
                    className="btn btn-secondary sw-btn-prev me-1"
                    onClick={() => setGoSteps(0)}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-primary sw-btn-next ms-1"
                    onClick={() => setGoSteps(2)}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
            {goSteps === 2 && (
              <>
                <Tab.Container defaultActiveKey={0}>
                  <Nav as="ul" className="nav-tabs">
                    <Nav.Item as="li" key={0}>
                      <Nav.Link eventKey={0}>
                        <img width={20} src={English} />
                        &nbsp; &nbsp; English
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={1}>
                      <Nav.Link eventKey={1}>
                        <img width={20} src={French} />
                        &nbsp; &nbsp; French
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={2}>
                      <Nav.Link eventKey={2}>
                        <img width={20} src={Spanish} />
                        &nbsp; &nbsp; Spanish
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={3}>
                      <Nav.Link eventKey={3}>
                        <img width={20} src={Portgual} />
                        &nbsp; &nbsp; Portugues
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" key={4}>
                      <Nav.Link eventKey={4}>
                        <img width={20} src={Arabic} />
                        &nbsp; &nbsp; Arabic
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content className="pt-4">
                    <Tab.Pane eventKey={0} key={0}>
                      <div className="card">
                        <div className="card-body">
                          <h4>Product Title</h4>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <h4 className="mt-4">Description</h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>

                          <h4 className="mt-3">History </h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey={1} key={1}>
                      <div className="card">
                        <div className="card-body">
                          <h4>Nom du produit</h4>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <h4 className="mt-4">Description</h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>

                          <h4 className="mt-3">Histoire </h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey={2} key={2}>
                      <div className="card">
                        <div className="card-body">
                          <h4>Título del producto</h4>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <h4 className="mt-4">Descripción</h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>

                          <h4 className="mt-3">Historia </h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey={3} key={3}>
                      <div className="card">
                        <div className="card-body">
                          <h4>Título do produto                          </h4>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                            />
                          </div>
                          <h4 className="mt-4">Descrição</h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>

                          <h4 className="mt-3">História </h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey={4} key={4}>
                      <div className="card">
                        <div className="card-body">
                          <h4 className="text-end">عنوان المنتج                          </h4>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control text-end"
                              placeholder=""
                            />
                          </div>
                          <h4 className="mt-4 text-end">الوصف</h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              config={{
                                language: "ar", // Sets the editor language to Arabic for proper text alignment and direction
                                contentsLangDirection: "rtl", // Sets the content direction to RTL
                                toolbar: {
                                  items: [
                                    "bold",
                                    "italic",
                                    "underline",
                                    "link",
                                    "bulletedList",
                                    "numberedList",
                                    "blockQuote",
                                    "undo",
                                    "redo",
                                  ],
                                },
                              }}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>

                          <h4 className="mt-3 text-end">التاريخ </h4>
                          <div className="form-group">
                            <CKEditor
                              editor={ClassicEditor}
                              config={{
                                language: "ar", // Sets the editor language to Arabic for proper text alignment and direction
                                contentsLangDirection: "rtl", // Sets the content direction to RTL
                                toolbar: {
                                  items: [
                                    "bold",
                                    "italic",
                                    "underline",
                                    "link",
                                    "bulletedList",
                                    "numberedList",
                                    "blockQuote",
                                    "undo",
                                    "redo",
                                  ],
                                },
                              }}
                              onReady={(editor) => {
                                console.log("Editor is ready to use!", editor);
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log({ event, editor, data });
                              }}
                              onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                              }}
                              onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>

                <div className="text-end toolbar toolbar-bottom p-2">
                  <button
                    className="btn btn-secondary sw-btn-prev me-1"
                    onClick={() => setGoSteps(1)}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-primary sw-btn-next ms-1"
                    onClick={() => setGoSteps(3)}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
            {goSteps === 3 && (
              <>
                <div className="text-end toolbar toolbar-bottom p-2">
                  <button
                    className="btn btn-secondary sw-btn-prev me-1"
                    onClick={() => setGoSteps(2)}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-primary sw-btn-next ms-1"
                    // onClick={() => setGoSteps("Validation")}
                  >
                    Submit
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Review Modal */}
      <Modal
        show={reviewToggle}
        onHide={() => setReviewToggle(false)}
        className="modal fade"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Review</h5>
            <button
              type="button"
              onClick={() => setReviewToggle(false)}
              className="btn-close"
            ></button>
          </div>
          <div className="modal-body">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setReviewToggle(false);
              }}
            >
              <div className="text-center mb-4">
                <img
                  className="img-fluid rounded"
                  width={78}
                  src={avater1}
                  alt="Avatar"
                />
              </div>
              <div className="form-group">
                <div className="rating-widget mb-4 text-center">
                  <div className="rating-stars">
                    <ul
                      id="stars"
                      className="d-flex justify-content-center align-items-center"
                    >
                      {[1, 2, 3, 4, 5].map((numb) => (
                        <li
                          className={`star me-1 ${numb <= star && "selected"}`}
                          key={numb}
                          onClick={() => setStar(numb)}
                        >
                          <i className="fa fa-star" />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="form-group mb-3">
                <textarea
                  className="form-control"
                  placeholder="Comment"
                  rows={5}
                ></textarea>
              </div>
              <button className="btn btn-success btn-block">Rate</button>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateProduct;
